<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('tournamentregistration.Header') }}</h2>
            <div id="ObererBereich" class="flexContainerRowSB-center">
                <div id="LinkerBereich">
                    <h3>{{ $t('tournamentregistration.HeaderTournamentSelection') }}</h3>
                    <Grid ref="gridTurniere"
                          :style="{ width: '600px' }"
                          :data-items="gridDataTurniereComputed"
                          :loader="loaderTurniere"
                          :selected-field="selectedFieldTurniere"
                          @rowclick="onRowClickedTurniere"
                          :columns="columnsTurniere">
                        <grid-norecords>{{ $t('tournamentregistration.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div id="RechterBereich">
                    <h3>{{ $t('tournamentregistration.HeaderFormTypes') }}</h3>
                    <combobox :style="{ width: '340px' }"
                              :data-items="comboDataFormenarten"
                              :text-field="'bezeichnung'"
                              :data-item-key="'refFormenarten'"
                              :value-field="'refFormenarten'"
                              :value-primitive="true"
                              @change="handleChangeFormenarten"
                              :value="selectedPrimFormenarten">
                    </combobox>
                </div>
            </div>
            <div id="UntererBereich" class="flexContainerRowSB-center">
                <div id="LinkerBereich" v-show="visibleKlassen">
                    <h3>{{ $t('tournamentregistration.HeaderClasses') }}</h3>
                    Filter: <KTextBox :value="filterValue"
                                      @change="filterChange"
                                      style="width:350px"
                                      :placeholder="$t('tournamentregistration.FilterClassesPlaceholder')">
                    </KTextBox>
                    <Grid ref="gridKlassen"
                          :style="{ width: '500px', height: '400px' }"
                          :data-items="gridDataKlassenComputed"
                          :loader="loaderKlassen"
                          :selected-field="selectedFieldKlassen"
                          @rowclick="onRowClickedKlassen"
                          :columns="columnsKlassen">
                        <grid-norecords>{{ $t('tournamentregistration.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div id="RechterBereich" v-show="visibleZugewieseneSportler">
                    <h3>{{ $t('tournamentregistration.HeaderAssignedAthletes') }}</h3>
                    <Grid ref="gridTeilnehmerZugeordnet"
                          :style="{ width: '750px', height: '400px' }"
                          :data-items="gridDataTeilnehmerZugeordnetComputed"
                          :loader="loaderTeilnehmerZugeordnet"
                          :selected-field="selectedFieldTeilnehmerZugeordnet"
                          @rowclick="onRowClickedTeilnehmerZugeordnet"
                          :columns="columnsTeilnehmerZugeordnet">
                        <grid-toolbar>
                            <kbutton title="Hinzufuegen" :theme-color="'primary'" @click="onHinzufuegenClick">
                                {{ $t('tournamentregistration.buttonAdd') }}
                            </kbutton>
                            <kbutton title="Bearbeiten" :theme-color="'primary'" @click="onBearbeitenClick">
                                {{ $t('tournamentregistration.buttonEdit') }}
                            </kbutton>
                            <kbutton title="Loeschen" :theme-color="'primary'" @click="onLoeschenClick">
                                {{ $t('tournamentregistration.buttonDelete') }}
                            </kbutton>
                        </grid-toolbar>
                        <grid-norecords>{{ $t('tournamentregistration.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
            </div>
            <k-dialog v-if="visibleDialog" :title="$t('tournamentregistration.HeaderAthleteSelection')" :closeIcon="false">
                <div id="FilterSportlerPaarTeam" v-if="showGridSportlerEinzel === true">
                    Filter: <KTextBox :value="filterValueSportlerauswahl"
                                      @change="filterChangeSportlerauswahl"
                                      style="width:350px"
                                      :placeholder="$t('tournamentregistration.FilterClassesPlaceholder')">
                    </KTextBox>
                </div>
                <div id="FilterSportlerPaarTeam" v-if="showGridSportlerEinzel === false">
                    Filter: <KTextBox :value="filterValueTeamauswahl"
                                      @change="filterChangeTeamauswahl"
                                      style="width:350px"
                                      :placeholder="$t('tournamentregistration.FilterClassesPlaceholder')">
                    </KTextBox>
                </div>
                <div class="k-form k-form-horizontal">
                    <div class="k-form-field">
                        <Grid v-if="showGridSportlerEinzel === true"
                              ref="gridSportlerauswahl"
                              :style="{ width: '400px', height: '400px' }"
                              :data-items="gridDataSportlerauswahlComputed"
                              :loader="loaderSportlerauswahl"
                              :selected-field="selectedFieldSportlerauswahl"
                              @rowclick="onRowClickedSportlerauswahl"
                              :columns="columnsSportlerauswahl">
                            <grid-norecords>{{ $t('tournamentregistration.NotificationNoData') }}</grid-norecords>
                        </Grid>
                        <Grid v-if="showGridSportlerEinzel === false"
                              ref="gridTeamauswahl"
                              :style="{ width: '400px', height: '400px' }"
                              :data-items="gridDataTeamauswahlComputed"
                              :loader="loaderTeamauswahl"
                              :selected-field="selectedFieldTeamauswahl"
                              @rowclick="onRowClickedTeamauswahl"
                              :columns="columnsTeamauswahl">
                            <grid-norecords>{{ $t('tournamentregistration.NotificationNoData') }}</grid-norecords>
                        </Grid>
                    </div>
                    <br />
                    <div id="FormenAuswahl" v-if="visibleFormenauswahl">
                        <p>1. Form</p>
                        <combobox :style="{ width: '340px' }"
                                  :data-items="comboDataForm1"
                                  :text-field="'nummerBezeichnung'"
                                  :data-item-key="'prim'"
                                  :value-field="'prim'"
                                  :value-primitive="true"
                                  @change="handleChangeForm1"
                                  :value="selectedPrimForm1">
                        </combobox>
                        <br />
                        <p>2. Form</p>
                        <combobox :style="{ width: '340px' }"
                                  :data-items="comboDataForm2"
                                  :text-field="'nummerBezeichnung'"
                                  :data-item-key="'prim'"
                                  :value-field="'prim'"
                                  :value-primitive="true"
                                  @change="handleChangeForm2"
                                  :value="selectedPrimForm2">
                        </combobox>
                    </div>
                    <br />
                </div>
                <br />
                <div id="Buttons">
                    <kbutton @click="onUebernehmenClick" class="k-button">{{ $t('tournamentregistration.buttonApply') }}</kbutton>&nbsp;&nbsp;&nbsp;
                    <kbutton @click="onAbbrechenClick" class="k-button">{{ $t('tournamentregistration.buttonCancel') }}</kbutton>
                </div>
            </k-dialog>
            <k-dialog v-if="visibleDialogEdit" :title="$t('tournamentregistration.HeaderAthleteSelection')" :closeIcon="false">
                <div class="k-form k-form-horizontal">
                    <label class="k-form-field">
                        <span>Name / Paar / Team</span>
                    </label>
                    <k-input v-model="nameOrTeam"
                             :disabled="true" />
                    <br />
                    <div id="FormenAuswahl">
                        <p>1. Form</p>
                        <combobox :style="{ width: '340px' }"
                                  :data-items="comboDataForm1"
                                  :text-field="'nummerBezeichnung'"
                                  :data-item-key="'prim'"
                                  :value-field="'prim'"
                                  :value-primitive="true"
                                  @change="handleChangeForm1"
                                  :value="selectedPrimForm1">
                        </combobox>
                        <br />
                        <p>2. Form</p>
                        <combobox :style="{ width: '340px' }"
                                  :data-items="comboDataForm2"
                                  :text-field="'nummerBezeichnung'"
                                  :data-item-key="'prim'"
                                  :value-field="'prim'"
                                  :value-primitive="true"
                                  @change="handleChangeForm2"
                                  :value="selectedPrimForm2">
                        </combobox>
                    </div>
                    <br />
                </div>
                <br />
                <div id="Buttons">
                    <kbutton @click="onUebernehmenEditClick" class="k-button">{{ $t('tournamentregistration.buttonApply') }}</kbutton>&nbsp;&nbsp;&nbsp;
                    <kbutton @click="onAbbrechenEditClick" class="k-button">{{ $t('tournamentregistration.buttonCancel') }}</kbutton>
                </div>
            </k-dialog>
            <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
                <Fade :appear="success">
                    <Notification v-if="success" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationSave') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="error">
                    <Notification v-if="error" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationError') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSquad">
                    <Notification v-if="errorSquad" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorSquad') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSquadEntireTeam">
                    <Notification v-if="errorSquadEntireTeam" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorSquadEntireTeam') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSquadMemberInNonAClass">
                    <Notification v-if="errorSquadMemberInNonAClass" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorSquadMemberInNonAClass') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSquadSquadMemberInTeam">
                    <Notification v-if="errorSquadMemberInTeam" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorSquadMemberInTeam') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorGender">
                    <Notification v-if="errorGender" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorGender') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorAge">
                    <Notification v-if="errorAge" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorAge') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorAgeAttacker">
                    <Notification v-if="errorAgeAttacker" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorAgeAttacker') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorAgeDefender">
                    <Notification v-if="errorAgeDefender" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorAgeDefender') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorGraduation">
                    <Notification v-if="errorGraduation" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorGraduation') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorGraduationDefender">
                    <Notification v-if="errorGraduationDefender" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorGraduationDefender') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorGraduationAttacker">
                    <Notification v-if="errorGraduationAttacker" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorGraduationAttacker') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPoomsae">
                    <Notification v-if="errorPoomsae" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorPoomsae') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSavePoomsae">
                    <Notification v-if="errorSavePoomsae" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorSavePoomsae') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="successSavePoomsae">
                    <Notification v-if="successSavePoomsae" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationSuccessSavePoomsae') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorMaxStarts">
                    <Notification v-if="errorMaxStarts" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('tournamentregistration.NotificationErrorMaxStarts') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </div>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Input } from '@progress/kendo-vue-inputs';
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { TextBox as KTextBox } from "@progress/kendo-vue-inputs";
    import config from "@/appdata/config.json";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'combobox': ComboBox,
            kbutton: Button,
            'k-input': Input,
            KTextBox,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                refVereine: 0,
                baseUrlTurniere: '',
                baseUrlKlassen: '',
                baseUrlTeilnehmerZugeordnet: '',
                baseUrlSportlerauswahl: '',
                baseComboUrlFormenarten: '',
                baseComboUrlFormen: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataTurniere: [],
                selectedFieldTurniere: "selectedTurniere",
                selectedPrimTurniere: 0,
                gridDataKlassen: [],
                filteredGridDataKlassen: [],
                selectedFieldKlassen: "selectedKlassen",
                selectedPrimKlassen: 0,
                gridDataTeilnehmerZugeordnet: [],
                selectedFieldTeilnehmerZugeordnet: "selectedTeilnehmerZugeordnet",
                selectedPrimTeilnehmerZugeordnet: 0,
                selectedAnzeigeNameTeilnehmerZugeordnet: '',
                gridDataSportlerauswahl: [],
                filteredGridDataSportlerauswahl: [],
                selectedFieldSportlerauswahl: "selectedSportlerauswahl",
                selectedPrimSportlerauswahl: 0,
                gridDataTeamauswahl: [],
                filteredGridDataTeamauswahl: [],
                selectedFieldTeamauswahl: "selectedTeamauswahl",
                selectedPrimTeamauswahl: 0,
                comboDataFormenarten: [],
                selectedPrimFormenarten: 0,
                comboDataForm1: [],
                selectedPrimForm1: 0,
                comboDataForm2: [],
                selectedPrimForm2: 0,
                deleteurlLoeschen: '',
                deleteurlFormen: '',
                posturlHinzufuegen: '',
                posturlFormen: '',
                patchurlPoomsaeEdit: '',
                visibleDialog: false,
                visibleFormenauswahl: false,
                visibleDialogEdit: false,
                visibleKlassen: false,
                visibleZugewieseneSportler: false,
                columnsTurniere: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 230, title: this.$t('tournamentregistration.GridColumnHeaderName') },
                    { field: "ort", editable: false, width: 120, title: this.$t('tournamentregistration.GridColumnHeaderLocation') },
                    { field: "datum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 100, title: this.$t('tournamentregistration.GridColumnHeaderDate') },
                    { field: "meldeschluss", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 120, title: this.$t('tournamentregistration.GridColumnHeaderClosingDate') },
                ],
                columnsKlassen: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "refKlasseneinteilung", hidden: true, editable: false, width: 120, title: "refKlasseneinteilung" },
                    { field: "refFormenarten", hidden: true, editable: false, width: 120, title: "refFormenarten" },
                    { field: "bezeichnung", editable: false, width: 350, title: this.$t('tournamentregistration.GridColumnHeaderDesignation') },
                ],
                columnsTeilnehmerZugeordnet: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "anzeigeName", editable: false, width: 300, title: this.$t('tournamentregistration.GridColumnHeaderName') },
                    { field: "form1", editable: false, width: 200, title: this.$t('tournamentregistration.GridColumnHeaderPoomsae1') },
                    { field: "form2", editable: false, width: 200, title: this.$t('tournamentregistration.GridColumnHeaderPoomsae2') },
                ],
                columnsSportlerauswahl: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "vornameName", editable: false, width: 300, title: this.$t('tournamentregistration.GridColumnHeaderName') },
                ],
                columnsTeamauswahl: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "anzeigeName", editable: false, width: 300, title: this.$t('tournamentregistration.GridColumnHeaderTeam') },
                ],
                loaderTurniere: false,
                totalTurniere: 0,
                loaderKlassen: false,
                totalKlassen: 0,
                loaderTeilnehmerZugeordnet: false,
                totalTeilnehmerZugeordnet: 0,
                loaderSportlerauswahl: false,
                totalSportlerauswahl: 0,
                loaderTeamauswahl: false,
                totalTeamauswahl: 0,
                showGridSportlerEinzel: false,
                success: false,
                error: false,
                errorSquad: false,
                errorSquadEntireTeam: false,
                errorGender: false,
                errorAge: false,
                errorAgeAttacker: false,
                errorAgeDefender: false,
                errorGraduation: false,
                errorGraduationDefender: false,
                errorGraduationAttacker: false,
                errorPoomsae: false,
                errorSavePoomsae: false,
                errorSquadMemberInTeam: false,
                errorSquadMemberInNonAClass: false,
                errorMaxStarts: false,
                successSavePoomsae: false,
                forceComputedUpdatex1: null,
                forceComputedUpdatex2: null,
                forceComputedUpdatex3: null,
                forceComputedUpdatex4: null,
                forceComputedUpdatex5: null,
                nameOrTeam: '',
                maxStartsCheck: 0,
                anzahlStarts: 0
            };
        },
        computed: {
            gridDataTurniereComputed() {
                if (this.forceComputedUpdatex1 === null || this.forceComputedUpdatex1 === 'undefined') {
                    return [];
                } else {
                    return this.gridDataTurniere.map((item) => ({ prim: item.prim, name: item.name, datum: item.datum, ort: item.ort, meldeschluss: item.meldeschluss, selectedTurniere: (item.prim === this.selectedPrimTurniere) }));
                }
            },
            gridDataKlassenComputed() {
                if (this.forceComputedUpdatex2 === null || this.forceComputedUpdatex2 === 'undefined') {
                    return [];
                } else {
                    return this.filteredGridDataKlassen.map((item) => ({ prim: item.prim, refKlasseneinteilung: item.refKlasseneinteilung, refFormenarten: item.refFormenarten, bezeichnung: item.bezeichnung, selectedKlassen: (item.refKlasseneinteilung === this.selectedPrimKlassen) }));
                }
            },
            gridDataTeilnehmerZugeordnetComputed() {
                if (this.forceComputedUpdatex3 === null || this.forceComputedUpdatex3 === 'undefined') {
                    return [];
                } else {
                    return this.gridDataTeilnehmerZugeordnet.map((item) => ({ prim: item.prim, anzeigeName: item.anzeigeName, form1: item.form1, form2: item.form2, selectedTeilnehmerZugeordnet: (item.prim === this.selectedPrimTeilnehmerZugeordnet) }));
                }
            },
            gridDataSportlerauswahlComputed() {
                if (this.forceComputedUpdatex4 === null || this.forceComputedUpdatex4 === 'undefined') {
                    return [];
                } else {
                    return this.filteredGridDataSportlerauswahl.map((item) => ({ prim: item.prim, vornameName: item.vornameName, selectedSportlerauswahl: (item.prim === this.selectedPrimSportlerauswahl) }));
                }
            },
            gridDataTeamauswahlComputed() {
                if (this.forceComputedUpdatex5 === null || this.forceComputedUpdatex5 === 'undefined') {
                    return [];
                } else {
                    return this.filteredGridDataTeamauswahl.map((item) => ({ prim: item.prim, anzeigeName: item.anzeigeName, selectedTeamauswahl: (item.prim === this.selectedPrimTeamauswahl) }));
                }
            },
        },
        created: function () {
            this.baseUrlTurniere = config[0].ServiceUrl + config[0].ServiceUrlPort + "/AktuelleTurniereManagement";
            this.getDataTurniere();
        },
        methods: {
            onRowClickedTurniere(event) {
                this.selectedPrimTurniere = event.dataItem.prim;
                this.visibleKlassen = false;
                this.visibleZugewieseneSportler = false;
                this.getDataFormenarten();
            },
            onRowClickedKlassen(event) {
                this.selectedPrimKlassen = event.dataItem.refKlasseneinteilung;
                this.visibleZugewieseneSportler = true;
                if (this.selectedPrimKlassen > 0) {
                    this.gridDataTeilnehmerZugeordnet = [];
                    this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                    this.getDataTeilnehmerZugeordnet();
                } else {
                    this.gridDataTeilnehmerZugeordnet = [];
                }               
            },
            onRowClickedTeilnehmerZugeordnet(event) {
                this.selectedPrimTeilnehmerZugeordnet = event.dataItem.prim;
                this.selectedAnzeigeNameTeilnehmerZugeordnet = event.dataItem.anzeigeName;
            },
            onRowClickedSportlerauswahl(event) {
                this.selectedPrimSportlerauswahl = event.dataItem.prim;
                this.selectedPrimForm1 = null;
                this.selectedPrimForm2 = null;
            },
            onRowClickedTeamauswahl(event) {
                this.selectedPrimTeamauswahl = event.dataItem.prim;
                this.selectedPrimForm1 = null;
                this.selectedPrimForm2 = null;
            },
            handleChangeFormenarten(event) {
                this.selectedPrimFormenarten = event.value;
                this.visibleZugewieseneSportler = false;
                this.visibleKlassen = true;
                this.baseUrlKlassen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/KlassenByTurniereManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten;
                this.getDataKlassen();
                //Hier wurde das Turnier fest ausgew�hlt - Nachlesen der Infos zu den Starts
                this.getTurniereMaxStarts();
            },
            handleChangeForm1(event) {
                this.selectedPrimForm1 = event.value;
            },
            handleChangeForm2(event) {
                this.selectedPrimForm2 = event.value;
            },
            getDataTurniere: function (initial) {
                this.forceComputedUpdatex1 = null
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTurniere,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex1 = new Date().getTime();
                            that.totalTurniere = total;
                            that.gridDataTurniere = data;
                            this.loaderTurniere = false;
                        } else {
                            this.forceComputedUpdatex1 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderTurniere = false;
                    });
            },
            getTurniereMaxStarts() {
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/MaxStartsCheck', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere
                    }
                })
                    .then((response) => {
                        this.maxStartsCheck = response.data[0].maxStartsCheck;
                        console.log("---->maxStartsCheck", this.maxStartsCheck);

                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            getDataKlassen: function (initial) {
                this.forceComputedUpdatex2 = null
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlKlassen,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex2 = new Date().getTime();
                            that.totalKlassen = total;
                            that.gridDataKlassen = data;
                            that.filteredGridDataKlassen = data;
                            this.loaderKlassen = false;
                        } else {
                            this.forceComputedUpdatex2 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderKlassen = false;
                    });
            },
            getDataTeilnehmerZugeordnet: function (initial) {
                console.log("---->", initial);
                this.forceComputedUpdatex3 = null;
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTeilnehmerZugeordnet,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length != 0) {
                            this.forceComputedUpdatex3 = new Date().getTime();
                            that.totalTeilnehmerZugeordnet = total;
                            that.gridDataTeilnehmerZugeordnet = data;
                            this.loaderTeilnehmerZugeordnet = false;
                        } else {
                            this.forceComputedUpdatex3 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderTeilnehmerZugeordnet = false;
                    });
            },
            getDataFormenarten: function () {
                this.selectedPrimFormenarten = null;
                this.baseComboUrlFormenarten = config[0].ServiceUrl + config[0].ServiceUrlPort + "/FormenartenByTurniereManagement?RefTurniere=" + this.selectedPrimTurniere;
                this.comboDataFormenarten = [];
                const that = this;
                fetch(this.baseComboUrlFormenarten, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataFormenarten = data;
                    });
            },
            getDataFormen: function () {
                this.selectedPrimForm1 = null;
                this.selectedPrimForm2 = null;
                this.baseComboUrlFormen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/FormenManagement";
                this.comboDataForm1 = [];
                this.comboDataForm2 = [];
                const that = this;
                fetch(this.baseComboUrlFormen, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataForm1 = data;
                        that.comboDataForm2 = data;
                    });
            },
            getDataSportlerauswahl: function (initial) {
                this.forceComputedUpdatex4 = null;
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlSportlerauswahl,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex4 = new Date().getTime();
                            that.totalSportlerauswahl = total;
                            that.gridDataSportlerauswahl = data;
                            that.filteredGridDataSportlerauswahl = data;
                            this.loaderSportlerauswahl = false;
                        } else {
                            this.forceComputedUpdatex4 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderSportlerauswahl = false;
                    });
            },
            getDataTeamauswahl: function (initial) {
                this.forceComputedUpdatex5 = null;
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTeamauswahl,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex5 = new Date().getTime();
                            that.totalTeamauswahl = total;
                            that.gridDataTeamauswahl = data;
                            that.filteredGridDataTeamauswahl = data;
                            this.loaderTeamauswahl = false;
                        } else {
                            this.forceComputedUpdatex5 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderTeamauswahl = false;
                    });
            },
            onLoeschenClick() {
                if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 6 || this.selectedPrimFormenarten === 7) {
                    //Erst Formen l�schen, dann Hauptdatensatz
                    this.deleteurlFormen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeilnehmerFormenByTurnierFormenartKlasse"
                    axios.delete(this.deleteurlFormen, { data: { refTurniere: this.selectedPrimTurniere, refFormenarten: this.selectedPrimFormenarten, refKlasseneinteilung: this.selectedPrimKlassen, refTeilnehmer: this.selectedPrimTeilnehmerZugeordnet } })
                        .then((response) => {
                            console.log("----------> success Formen l�schen", response);
                            //Hauptdatensatz l�schen
                            this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeilnehmerByTurnierFormenartKlasse"
                            axios.delete(this.deleteurlLoeschen, { data: { refTurniere: this.selectedPrimTurniere, refFormenarten: this.selectedPrimFormenarten, refKlasseneinteilung: this.selectedPrimKlassen, refTeilnehmer: this.selectedPrimTeilnehmerZugeordnet } })
                                .then((response) => {
                                    console.log("----------> success", response);
                                    //Grid neu laden
                                    this.gridDataTeilnehmerZugeordnet = [];
                                    this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                                    this.getDataTeilnehmerZugeordnet();
                                })
                                .catch((error) => {
                                    console.log("---------> error", error);
                                });
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                        });
                } else {
                    //Nur Datensatz l�schen, ohne Formen
                    this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeilnehmerByTurnierFormenartKlasse"
                    axios.delete(this.deleteurlLoeschen, { data: { refTurniere: this.selectedPrimTurniere, refFormenarten: this.selectedPrimFormenarten, refKlasseneinteilung: this.selectedPrimKlassen, refTeilnehmer: this.selectedPrimTeilnehmerZugeordnet } })
                        .then((response) => {
                            console.log("----------> success", response);
                            //Grid neu laden
                            this.gridDataTeilnehmerZugeordnet = [];
                            this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                            this.getDataTeilnehmerZugeordnet();
                        })
                        .catch((error) => {
                            console.log("---------> error", error);
                        });
                }
               
            },
            onHinzufuegenClick() {
                //Check, ob bereits max. Anzahl erreicht wurde
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/AnzahlStartsByTurniere', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere
                    }
                })
                    .then((response) => {
                        this.anzahlStarts = response.data[0].anzahl;
                        if (this.anzahlStarts < this.maxStartsCheck) {
                            //Unterscheidung nach Formenarten Einzel oder Paar/Team
                            if (this.selectedPrimFormenarten < 4) {
                                this.showGridSportlerEinzel = true;
                                //Einzel
                                this.gridDataSportlerauswahl = [];
                                this.baseUrlSportlerauswahl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerUndFreigabenByVereinManagement?RefVereine=" + store.primVerein;
                                this.getDataSportlerauswahl();
                            } else {
                                //Paar / Team
                                this.showGridSportlerEinzel = false;
                                this.gridDataTeamauswahl = [];
                                this.baseUrlTeamauswahl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                                this.getDataTeamauswahl();
                            }
                            if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 6 || this.selectedPrimFormenarten === 7) {
                                this.getDataFormen();
                                this.visibleFormenauswahl = true;
                                this.visibleDialog = true;
                            } else {
                                this.selectedPrimForm1 = null;
                                this.selectedPrimForm2 = null;
                                this.visibleFormenauswahl = false;
                                this.visibleDialog = true;
                            }
                        } else {
                            this.showNotificationErrorMaxStarts();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            onBearbeitenClick() {
                if (this.selectedPrimTeilnehmerZugeordnet > 0) {
                    if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 6 || this.selectedPrimFormenarten === 7) {
                        this.getDataFormen();
                        this.nameOrTeam = this.selectedAnzeigeNameTeilnehmerZugeordnet;
                        //Formen auslesen
                        axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/FormenByTurnierFormenartKlasse', {
                            params: {
                                RefTurniere: this.selectedPrimTurniere,
                                RefFormenarten: this.selectedPrimFormenarten,
                                RefKlasseneinteilung: this.selectedPrimKlassen,
                                RefTeilnehmer: this.selectedPrimTeilnehmerZugeordnet
                            }
                        })
                            .then((response) => {
                                this.selectedPrimForm1 = response.data[0].refForm1;
                                this.selectedPrimForm2 = response.data[0].refForm2;
                                this.visibleDialogEdit = true;
                            })
                            .catch(error => {
                                console.log(error)
                                this.errored = true
                                this.visibleDialogEdit = true;
                            })
                    } else {
                        console.log("-----------> keine Formen,keine Bearbeitung");
                    }
                }
            },
            onAbbrechenEditClick() {
                console.log("----------> Abbrechen");
                this.visibleDialogEdit = false;
            },
            onUebernehmenEditClick() {
                const parameters = {
                    "refTurniere": this.selectedPrimTurniere,
                    "refFormenarten": this.selectedPrimFormenarten,
                    "refKlasseneinteilung": this.selectedPrimKlassen,
                    "refTeilnehmer": this.selectedPrimTeilnehmerZugeordnet,
                    "refForm1": this.selectedPrimForm1,
                    "refForm2": this.selectedPrimForm2
                };
                this.patchurlPoomsaeEdit = config[0].ServiceUrl + config[0].ServiceUrlPort + "/UpdateTeilnehmerFormenByTurnierFormenartKlasse"
                axios.patch(this.patchurlPoomsaeEdit, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccessSavePoomsae()
                        this.visibleDialogEdit = false;
                        //Grid neu laden
                        this.gridDataTeilnehmerZugeordnet = [];
                        this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                        this.getDataTeilnehmerZugeordnet();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationErrorSavePoomsae(); 
                        this.visibleDialogEdit = false;
                        //Grid neu laden
                        this.gridDataTeilnehmerZugeordnet = [];
                        this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                        this.getDataTeilnehmerZugeordnet();
                    });
            },
            onUebernehmenClick() {
                //Unterscheidung Einzel oder Paar / Team
                let SportlerOderTeam = 0;
                if (this.selectedPrimFormenarten < 4) {
                    SportlerOderTeam = this.selectedPrimSportlerauswahl
                } else {
                    SportlerOderTeam = this.selectedPrimTeamauswahl
                }
                //Pr�fungen vor der �bernahme
                //1) A-Class - Kader
                //2) Geschlechts Pr�fung
                //3) Alters Pr�fung
                //4) Graduierung Pr�fung
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/RegistrationKaderCheck', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere,
                        RefFormenarten: this.selectedPrimFormenarten,
                        RefKlasseneinteilung: this.selectedPrimKlassen,
                        RefTeilnehmer: SportlerOderTeam
                    }
                })
                    .then((response) => {
                        const kaderCheck = response.data[0].kaderCheck.toString();
                        if (kaderCheck === '0' || kaderCheck === '1' || kaderCheck === '4') {
                            //2) Geschlechts Pr�fung
                            axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/RegistrationGeschlechtCheck', {
                                params: {
                                    RefFormenarten: this.selectedPrimFormenarten,
                                    RefKlasseneinteilung: this.selectedPrimKlassen,
                                    RefTeilnehmer: SportlerOderTeam
                                }
                            })
                                .then((response) => {
                                    const geschlechtCheck = response.data[0].geschlechtCheck.toString();
                                    if (geschlechtCheck === '1') {
                                        //3) Alters Pr�fung
                                        axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/RegistrationAlterCheck', {
                                            params: {
                                                RefFormenarten: this.selectedPrimFormenarten,
                                                RefKlasseneinteilung: this.selectedPrimKlassen,
                                                RefTeilnehmer: SportlerOderTeam
                                            }
                                        })
                                            .then((response) => {
                                                const alterCheck = response.data[0].alterCheck.toString();
                                                if (alterCheck === '1') {
                                                    //4) Graduierung Pr�fung
                                                    axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/RegistrationGraduierungCheck', {
                                                        params: {
                                                            RefFormenarten: this.selectedPrimFormenarten,
                                                            RefKlasseneinteilung: this.selectedPrimKlassen,
                                                            RefTeilnehmer: SportlerOderTeam
                                                        }
                                                    })
                                                        .then((response) => {
                                                            const graduierungCheck = response.data[0].graduierungCheck.toString();
                                                            if (graduierungCheck === '1') {
                                                                if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 6 || this.selectedPrimFormenarten === 7) {
                                                                    if (this.selectedPrimForm1 > 0 && this.selectedPrimForm2 > 0) {
                                                                        //Speichern mit Formen
                                                                        const parameters = {
                                                                            "refTurniere": this.selectedPrimTurniere,
                                                                            "refFormenarten": this.selectedPrimFormenarten,
                                                                            "refKlasseneinteilung": this.selectedPrimKlassen,
                                                                            "refTeilnehmer": SportlerOderTeam,
                                                                        };
                                                                        this.posturlHinzufuegen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerByTurnierFormenartKlasse"
                                                                        axios.post(this.posturlHinzufuegen, parameters)
                                                                            .then((response) => {
                                                                                console.log("----------> success Hinzufuegen", response);
                                                                                const parameters = {
                                                                                    "refTurniere": this.selectedPrimTurniere,
                                                                                    "refFormenarten": this.selectedPrimFormenarten,
                                                                                    "refKlasseneinteilung": this.selectedPrimKlassen,
                                                                                    "refTeilnehmer": SportlerOderTeam,
                                                                                    "refForm1": this.selectedPrimForm1,
                                                                                    "refForm2": this.selectedPrimForm2,
                                                                                };
                                                                                this.posturlFormen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerFormenByTurnierFormenartKlasse"
                                                                                axios.post(this.posturlFormen, parameters)
                                                                                    .then((response) => {
                                                                                        console.log("----------> success Formen gespeichert", response);
                                                                                        this.showNotificationSuccess();
                                                                                        this.visibleDialog = false;
                                                                                        //Grid neu laden
                                                                                        this.gridDataTeilnehmerZugeordnet = [];
                                                                                        this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                                                                                        this.getDataTeilnehmerZugeordnet();
                                                                                    })
                                                                                    .catch((error) => {
                                                                                        console.log("---------> error", error);
                                                                                        this.showNotificationError();
                                                                                        this.visibleDialog = false;
                                                                                    });
                                                                            })
                                                                            .catch((error) => {
                                                                                console.log("---------> error", error);
                                                                                this.showNotificationError();
                                                                                this.visibleDialog = false;
                                                                            });
                                                                    } else {
                                                                        this.showNotificationErrorPoomsae();
                                                                    }
                                                                } else {
                                                                    //Nur Speichern ohne Formen
                                                                    const parameters = {
                                                                        "refTurniere": this.selectedPrimTurniere,
                                                                        "refFormenarten": this.selectedPrimFormenarten,
                                                                        "refKlasseneinteilung": this.selectedPrimKlassen,
                                                                        "refTeilnehmer": SportlerOderTeam,
                                                                    };
                                                                    this.posturlHinzufuegen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerByTurnierFormenartKlasse"
                                                                    axios.post(this.posturlHinzufuegen, parameters)
                                                                        .then((response) => {
                                                                            console.log("----------> success Hinzufuegen", response);
                                                                            this.showNotificationSuccess();
                                                                            //Grid neu laden
                                                                            this.gridDataTeilnehmerZugeordnet = [];
                                                                            this.baseUrlTeilnehmerZugeordnet = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerByTurnierFormenartKlasseManagement?RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten + "&RefKlasseneinteilung=" + this.selectedPrimKlassen + "&RefVereine=" + store.primVerein;
                                                                            this.getDataTeilnehmerZugeordnet();
                                                                            this.visibleDialog = false;
                                                                        })
                                                                        .catch((error) => {
                                                                            console.log("---------> error", error);
                                                                            this.showNotificationError();
                                                                            this.visibleDialog = false;
                                                                        });
                                                                }
                                                            } else if (graduierungCheck === '4') {
                                                                this.showNotificationErrorGraduationDefender();
                                                            } else if (graduierungCheck === '5') {
                                                                this.showNotificationErrorGraduationAttacker();
                                                            } else {
                                                                this.showNotificationErrorGraduation();
                                                            }
                                                        })
                                                        .catch(error => {
                                                            console.log(error)
                                                            this.errored = true
                                                        })
                                                } else if (alterCheck === '4') {
                                                    this.showNotificationErrorAgeDefender();
                                                } else if (alterCheck === '5') {
                                                    this.showNotificationErrorAgeAttacker();
                                                } else {
                                                    this.showNotificationErrorAge();
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error)
                                                this.errored = true
                                            })
                                    } else {
                                        this.showNotificationErrorGender();
                                    }
                                })
                                .catch(error => {
                                    console.log(error)
                                    this.errored = true
                                })
                        } else if (kaderCheck === '5') {
                            this.showNotificationErrorSquadEntireTeam();
                        } else if (kaderCheck === '6') {
                            this.showNotificationErrorSquadMemberInNonAClass();
                        } else if (kaderCheck === '7') {
                            this.showNotificationErrorSquadMemberInTeam();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })

                
            },
            onAbbrechenClick() {
                this.visibleDialog = false;
            },
            filterChangeTeamauswahl(event) {
                const filterValueTeamauswahl = event.target.value.toLowerCase();
                this.filteredGridDataTeamauswahl = this.gridDataTeamauswahl.filter(obj => {
                    return obj.anzeigeName.toLowerCase().includes(filterValueTeamauswahl)
                });
            },
            filterChangeSportlerauswahl(event) {
                const filterValueSportlerauswahl = event.target.value.toLowerCase();
                this.filteredGridDataSportlerauswahl = this.gridDataSportlerauswahl.filter(obj => {
                    return obj.vornameName.toLowerCase().includes(filterValueSportlerauswahl)
                });
            },
            filterChange(event) {
                const filterValue = event.target.value.toLowerCase();
                this.filteredGridDataKlassen = this.gridDataKlassen.filter(obj => {
                    return obj.bezeichnung.toLowerCase().includes(filterValue)
                });
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            },
            showNotificationErrorSquad() {
                /*Meldung anzeigen*/
                this.errorSquad = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSquad = false;
                }, 3000);
            },
            showNotificationErrorSquadEntireTeam() {
                /*Meldung anzeigen*/
                this.errorSquadEntireTeam = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSquadEntireTeam = false;
                }, 3000);
            },
            showNotificationErrorSquadMemberInNonAClass() {
                /*Meldung anzeigen*/
                this.errorSquadMemberInNonAClass = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSquadMemberInNonAClass = false;
                }, 3000);
            },
            showNotificationErrorSquadMemberInTeam() {
                /*Meldung anzeigen*/
                this.errorSquadMemberInTeam = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSquadMemberInTeam = false;
                }, 3000);
            },
            showNotificationErrorGender() {
                /*Meldung anzeigen*/
                this.errorGender = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorGender = false;
                }, 3000);
            },
            showNotificationErrorAge() {
                /*Meldung anzeigen*/
                this.errorAge = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorAge = false;
                }, 3000);
            },
            showNotificationErrorAgeDefender() {
                /*Meldung anzeigen*/
                this.errorAgeDefender = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorAgeDefender = false;
                }, 3000);
            },
            showNotificationErrorAgeAttacker() {
                /*Meldung anzeigen*/
                this.errorAgeAttacker = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorAgeAttacker = false;
                }, 3000);
            },
            showNotificationErrorGraduation() {
                /*Meldung anzeigen*/
                this.errorGraduation = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorGraduation = false;
                }, 3000);
            },
            showNotificationErrorGraduationDefender() {
                /*Meldung anzeigen*/
                this.errorGraduationDefender = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorGraduationDefender = false;
                }, 3000);
            },
            showNotificationErrorGraduationAttacker() {
                /*Meldung anzeigen*/
                this.errorGraduationAttacker = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorGraduationAttacker = false;
                }, 3000);
            },
            showNotificationErrorPoomsae() {
                /*Meldung anzeigen*/
                this.errorPoomsae = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPoomsae = false;
                }, 3000);
            },
            showNotificationErrorSavePoomsae() {
                /*Meldung anzeigen*/
                this.errorSavePoomsae = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSavePoomsae = false;
                }, 3000);
            },
            showNotificationSuccessSavePoomsae() {
                /*Meldung anzeigen*/
                this.successSavePoomsae = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successSavePoomsae = false;
                }, 3000);
            },
            showNotificationErrorMaxStarts() {
                /*Meldung anzeigen*/
                this.errorMaxStarts = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorMaxStarts = false;
                }, 3000);
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
